import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import styled from 'styled-components';
import { logoutUser } from '../../store/authSlice';
import { DashboardThemeProvider } from '../../context/DashboardThemeContext';
import Sidebar from './Sidebar';
import Header from './Header';
import Overview from './Overview';
import TradingView from './TradingView';
import Portfolio from './Portfolio';

const DashboardContainer = styled.div`
  display: flex;
  min-height: 100vh;
  background: ${(p) => p.theme.pageBg};
  color: ${(p) => p.theme.textPrimary};
  transition: background 0.2s ease, color 0.2s ease;
`;

const MainContent = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  margin-left: 280px;
  
  @media (max-width: 768px) {
    margin-left: 0;
  }
`;

const ContentArea = styled.div`
  flex: 1;
  padding: 24px;
  overflow-y: auto;
`;

const Dashboard = () => {
  const [activeTab, setActiveTab] = useState('overview');
  const { user, isAuthenticated } = useSelector(state => state.auth);
  const dispatch = useDispatch();

  useEffect(() => {
    if (!isAuthenticated) {
      // Redirect to login if not authenticated
      window.location.href = '/login';
    }
  }, [isAuthenticated]);

  const handleLogout = () => {
    dispatch(logoutUser());
  };

  const renderContent = () => {
    switch (activeTab) {
      case 'overview':
        return <Overview />;
      case 'trading':
        return <TradingView />;
      case 'portfolio':
        return <Portfolio />;
      default:
        return <Overview />;
    }
  };

  if (!isAuthenticated) {
    return null; // Will redirect to login
  }

  return (
    <DashboardThemeProvider>
      <DashboardContainer>
        <Sidebar activeTab={activeTab} setActiveTab={setActiveTab} />
        <MainContent>
          <Header user={user} onLogout={handleLogout} />
          <ContentArea>{renderContent()}</ContentArea>
        </MainContent>
      </DashboardContainer>
    </DashboardThemeProvider>
  );
};

export default Dashboard;
